import { Link } from '@material-ui/core'
import { privacyLink, termsLink_external } from 'constants/links'
import { Typography } from 'opensolar-ui'
import useTranslateParse from 'util/useTranslateParse'

export const TermsAndPrivacyLinks = ({ align = 'left' }: { align?: 'left' | 'center' }) => {
  const translateParse = useTranslateParse()

  return (
    <Typography align={align}>
      {translateParse('By proceeding you agree to the <a1>Terms & Conditions<a1> and <a2>Privacy Notice<a2>', {
        a1: (label) => (
          <Link href={termsLink_external} key="terms_and_conditions" target="_blank">
            {label}
          </Link>
        ),
        a2: (label) => (
          <Link href={privacyLink} key="privacy_notice" target="_blank">
            {label}
          </Link>
        ),
      })}
    </Typography>
  )
}
